<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-card class="pa-1">        
        <Title :title="'お知らせ'+(notOpenedNotificationNum > 0 ? '(未読'+notOpenedNotificationNum+'通)' : '')" dense @click="isExpand = !isExpand" icon="mdi-send" >
            <v-spacer />
            <v-btn small icon elevation="0" @click.stop="isExpand = !isExpand">
                <v-icon v-if="isExpand">mdi-chevron-up</v-icon>
                <v-icon v-if="!isExpand">mdi-chevron-down</v-icon>
            </v-btn>
        </Title>
        <v-expand-transition>
            <v-card-text v-if="isExpand" class="pa-1">
                <v-simple-table v-if="!$vuetify.breakpoint.xs" height="200" fixed-header dense>
                    <thead>
                        <tr>
                            <th class="text-center"></th>
                            <th class="text-left">件名</th>
                            <th class="text-left" width="200">差出人</th>
                            <th class="text-left" width="200">日時</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="notification in notifications" :key="notification.body.dateTime" @click="onClickNotification(notification)" :class="notificationColor(notification.body)+'--text'">
                            <td class="text-center pl-1 pr-1">
                                <v-icon v-if="notification.body.openedDateTime == ''" color="green">mdi-new-box</v-icon>
                            </td>
                            <td class="text-left pl-1"><v-icon :color="notificationColor(notification.body)">{{icon(notification.body)}}</v-icon> {{notification.body.content.title}}</td>
                            <td class="text-left" style="white-space:nowrap">
                                <v-avatar class="ma-0" size="24" rounded>
                                    <v-img v-if="notification.sender.userUID == ''" src="@/assets/icon-72x72_no_bg.png"/>
                                    <v-img v-else-if="notification.sender.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                    <v-img v-else-if="notification.sender.avaterURL != null" :src="notification.sender.avaterURL"/>
                                </v-avatar>
                                <span v-if="notification.sender.userUID != ''">{{notification.sender.userName}}</span>
                                <span v-else>【圃場管理システム】</span>
                            </td>
                            <td class="text-left">{{notification.body.dateTime}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <v-simple-table v-if="$vuetify.breakpoint.xs" height="200" fixed-header>
                    <tbody>
                        <tr>
                            <td class="pr-2 pl-2">
                                <v-container fluid class="pa-0">
                                    <v-row dense>
                                        <v-col class="pa-0">
                                            <v-card
                                                v-for="notification in notifications" 
                                                :key="notification.body.dateTime" 
                                                @click="onClickNotification(notification)" 
                                                :color="notificationColor(notification.body)+'--text'"
                                                class="mb-2 mt-2 pa-1">
                                                <v-icon v-if="notification.body.openedDateTime == ''" color="green">mdi-new-box</v-icon>
                                                <v-icon :color="notificationColor(notification.body)">{{icon(notification.body)}}</v-icon>
                                                <span class="caption">{{notification.body.content.title}}<br/></span>
                                                <span class="caption" v-if="notification.sender.userUID != ''">差出人:{{notification.sender.userName}}<br/></span>
                                                <span class="caption" v-else>差出人:【圃場管理システム】<br/></span>
                                                <span style="font-size:xx-small">受信日時:{{notification.body.dateTime}}</span>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-card-text>
        </v-expand-transition>
        <Viewer ref="viewer" />
    </v-card>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import Viewer from '@/components/notification/items/NotificationViewer'
    export default {
        name: 'Notification',        
        components: {
            Viewer,
            Title
        },
        data: function () {
            return {
                isExpand: this.$vuetify.breakpoint.xs ? false : true,
            }
        },
        computed: {
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            userData: function () {
                return this.$store.getters["userData"]
            },
            notifications: function () {
                const receivedList = this.$store.getters["managementItems/notifications"].receiveList.list
                if (receivedList.length <= 0) {
                    return []
                }
                const list = []

                for (var i=0; i<5; i++) {
                    list.push(receivedList[i])
                    if (list.length == receivedList.length) {
                        return list
                    }
                }
                return list
            },
            notOpenedNotificationNum: function () {
                const list = this.$store.getters["managementItems/notifications"].receiveList.list
                var num = 0
                for (var i=0; i<list.length; i++) {
                    if (list[i].body.openedDateTime == "") {
                        num++
                    }
                }
                return num
            }
        },
        // created: function () {
        //     this.refresh()
        // },
        methods: {
            icon: function (notification) {
                switch (notification.content.type) {
                    case 1:
                        return "mdi-information"
                    case 10:
                    case 11:
                    case 12:
                        return "mdi-share-variant"
                    case 13:
                        switch (notification.data.type) {
                            case 0:
                                return "mdi-information"
                            case 1:
                                return "mdi-alert"
                        }
                        break
                    case 20:
                        return "mdi-comment-account"
                    case 30:
                        return "mdi-file-document-edit-outline"
                    case 90:
                        return "mdi-message-alert"
                }
            },
            notificationColor: function (notification) {
                switch (notification.content.type) {
                    case 13:
                        switch (notification.data.type) {
                            case 1:
                                return "red"
                        }
                        break
                }
            },
            /**
             * 通知クリック時
             */
            onClickNotification: function (notification) {
                console.log("Notification", "onClickNotification", notification)
                this.$refs.viewer.show(notification)
            }
        }
    }
</script>